import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography, useMediaQuery } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import LookUpForm from '../LookUp/LookUpForm';
import cardHeader from '../../assets/cardHeader.jpg';
import { useState } from 'react';
import WarrantyDetail from './WarrantyDetail';
import agent from '../../app/api/agent';
import { Warranty } from '../../app/models/warranty';

const LookUp = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('Please enter your Warranty Number or Serial Number to look up warranty');
    const [isError, setIsError] = useState(false);
    const [isFormEmpty, setIsFormEmpty] = useState(false);
    const [warrantyData, setWarrantyData] = useState<Warranty | null>(null);

    const matches = useMediaQuery('(min-width:600px)');

    const lookUpHandler = async (values: any) => {
        setIsLoading(true);
        setWarrantyData(null);
        setIsError(false);

        if (values.warrantyNumber || values.serialNumber) {
            setIsFormEmpty(false);
            try {
                setIsLoading(true);
                setMessage('We are working on your request...');
                const response = await agent.warranty.lookUpWarranty(values.warrantyNumber, values.serialNumber);
                if (response) {
                    if (response.errorMessage !== null) {
                        setMessage(response.errorMessage);
                        setWarrantyData(null);
                        setIsError(true);
                    }
                    else {
                        setWarrantyData(response);
                        setMessage('Please enter your Warranty Number or Serial Number to look up warranty');
                        setIsError(false);
                    }
                    setIsLoading(false);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                setMessage('Server is busy, try after sometime');
            }
            setIsLoading(false);
        } else {
            setIsFormEmpty(true);
            setIsLoading(false);
            setMessage('Warranty Number or Serial Number is required!')
        }
    }
    const warrantyDetailHandler = () => {
        setWarrantyData(null);
        setMessage('Please enter your Warranty Number or Serial Number to look up warranty');
        setIsFormEmpty(false);
        setIsLoading(false);
        setIsError(false);
    }

    return (
        <Box className='masthead'>
            <Box sx={{ width: '100%', p: 2, mt: matches ? 20 : 4 }}>
                <Card sx={{ width: matches ? 600 : 360, m: '0 auto', pt: 2, pb: 2 }}>
                    <Typography align='center' variant='h5' color='black' gutterBottom>
                        Warranty Lookup
                    </Typography>
                    <CardMedia
                        component="img"
                        height="200"
                        image={cardHeader}
                        alt="green iguana"
                    />
                    <CardActions>
                        {warrantyData &&
                            <WarrantyDetail warrantyDetailHandler={warrantyDetailHandler} warrantyData={warrantyData} />}
                        {!warrantyData &&
                            <LookUpForm lookUpHandler={lookUpHandler} loading={isLoading} isFormEmpty={isFormEmpty} message={message} isError={isError} />}
                    </CardActions>
                </Card>
            </Box>
        </Box>
    );
}

export default LookUp